import { ThunkType } from "../../../../core/store/reducers";
import { getBankGuaranteesExcel } from "../api/getBankGuaranteesExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../bankguaranteesDataSlice";

export const downloadBankGuaranteesExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }
  
  const { filter } = store.ux.clearing.bankguarantees;
  const user = store.data.auth.current.user;

  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getBankGuaranteesExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "BankGuarantees.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
